import { FC } from "react";
import { useTheme } from "@mui/system";
import ReactApexChart from "react-apexcharts";

interface Props {
  height: string | number;
}
const BasicDonutChart2: FC<Props> = ({ height }) => {
  const theme = useTheme();
  const series = [75, 25];
  const options: object = {
    chart: {
      width: "100%",
      type: "donut",
      background: "transparent",
    },
    series: [75, 25],
    labels: ["Complete", "Pending"],
    colors: [theme.palette.primary.main, theme.palette.primary[200]],
    plotOptions: {
      pie: {
        donut: {
          size: "80%",
          labels: {
            show: true,
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    theme: {
      mode: theme.palette.mode,
    },
    stroke: {
      show: true,
      colors: [
        theme.palette.mode === "light"
          ? "#fff"
          : theme.palette.background.paper,
      ],
    },
  };
  return (
    <ReactApexChart
      options={options}
      series={series}
      type="donut"
      height={height}
    />
  );
};

export default BasicDonutChart2;
